import {
  BULK_DESTROY_LAUNDRY_SERVICE_TYPES,
  CREATE_LAUNDRY_SERVICE_TYPE,
  EDIT_LAUNDRY,
  FETCH_LAUNDRY,
  FETCH_LAUNDRY_INIT,
  FETCH_LAUNDRY_SERVICE_TYPES,
  GET_DETACHEDS,
  REMOVE_LAUNDRY_SERVICE_TYPE,
  UPDATE_LAUNDRY_SERVICE_TYPE,
} from './PartnersActions'

const INITIAL_STATE = {
  items: [],
  meta: {},
  filters: {},
  paymentMethods: [],
  streetAttendants: [],
  weeks: [],
  laundryServiceTypes: [],
  serviceTypes: [],
  laundryServiceTypesLoading: false,
  editingLaundry: {
    id: '',
    name: '',
    company_name: '',
    contact_name: '',
    email: '',
    cep: '',
    street: '',
    number: '',
    complement: '',
    observations: '',
    neighborhood: '',
    city: '',
    uf: '',
    cnpj: '',
    phone: '',
    phone2: '',
    status: true,
    payment_method: '',
    payment_method_id: '',
    attendants: [],
  },
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LAUNDRY.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        meta: action.payload.data.meta,
        paymentMethods: action.payload.data.paymentMethods,
        streetAttendants: action.payload.data.streetAttendants,
        weeks: action.payload.data.weeks,
        filters: action.payload.filters,
      }
    case FETCH_LAUNDRY_INIT.SUCCESS:
      return {
        ...state,
        paymentMethods: action.payload.data.paymentMethods,
        weeks: action.payload.data.weeks,
      }
    case EDIT_LAUNDRY.SUCCESS:
      return {
        ...state,
        editingLaundry: {
          ...action.payload.data,
        },
      }
    case GET_DETACHEDS.SUCCESS:
      return {
        ...state,
        appointments: action.payload.appointments,
      }
    case FETCH_LAUNDRY_SERVICE_TYPES.ACTION:
      return {
        ...state,
        laundryServiceTypesLoading: true,
      }
    case FETCH_LAUNDRY_SERVICE_TYPES.SUCCESS:
      return {
        ...state,
        laundryServiceTypes: action.payload?.data?.data || [],
        serviceTypes: action.payload.data.service_types,
        laundryServiceTypesLoading: false,
      }
    case FETCH_LAUNDRY_SERVICE_TYPES.FAILURE:
      return {
        ...state,
        laundryServiceTypesLoading: false,
      }
    case CREATE_LAUNDRY_SERVICE_TYPE.ACTION:
    case UPDATE_LAUNDRY_SERVICE_TYPE.ACTION:
    case REMOVE_LAUNDRY_SERVICE_TYPE.ACTION:
    case BULK_DESTROY_LAUNDRY_SERVICE_TYPES.ACTION:
      return {
        ...state,
        laundryServiceTypesLoading: true,
      }
    case CREATE_LAUNDRY_SERVICE_TYPE.SUCCESS:
    case CREATE_LAUNDRY_SERVICE_TYPE.FAILURE:
    case UPDATE_LAUNDRY_SERVICE_TYPE.SUCCESS:
    case UPDATE_LAUNDRY_SERVICE_TYPE.FAILURE:
    case REMOVE_LAUNDRY_SERVICE_TYPE.SUCCESS:
    case REMOVE_LAUNDRY_SERVICE_TYPE.FAILURE:
    case BULK_DESTROY_LAUNDRY_SERVICE_TYPES.SUCCESS:
    case BULK_DESTROY_LAUNDRY_SERVICE_TYPES.FAILURE:
      return {
        ...state,
        laundryServiceTypesLoading: false,
      }
    default:
      return state
  }
}

export const getLaundryListData = state => {
  return {
    items: state.laundry.items,
    filters: state.laundry.filters,
  }
}

export const getEditingLaundry = state => {
  return state.laundry.editingLaundry
}
